import React from "react";
import { Check } from "lucide-react";
import { Tile, fmtDate } from "./primitives";

export default function MedFeedbackPanel({ medFeedback, onChangeStatus }) {
  const items = medFeedback?.items || [];
  const newCount = medFeedback?.counts?.new ?? 0;
  return (
    <Tile title={`Feedback inbox · ${newCount} new`} testid="tile-med-feedback">
      {items.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">
          No feedback yet. The form on /medication-safety funnels here.
        </div>
      ) : (
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {items.map((f) => (
            <div
              key={f.id}
              data-testid={`fb-${f.id}`}
              className="text-xs border-b border-[#F0EFEA] pb-2 last:border-0"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-[10px] uppercase tracking-wider font-semibold text-[#2B5339]">
                  {f.kind}
                </span>
                <span
                  className={`text-[10px] px-2 py-0.5 rounded-full ${
                    f.status === "resolved"
                      ? "bg-[#E8F0EB] text-[#2B5339]"
                      : f.status === "reviewed"
                        ? "bg-[#F0EFEA] text-[#5C6B62]"
                        : "bg-[#FDF2ED] text-[#C26747]"
                  }`}
                >
                  {f.status}
                </span>
              </div>
              <div className="text-[#1C2B23] mt-1 whitespace-pre-wrap">{f.message}</div>
              {(f.contact || f.context) && (
                <div className="text-[#5C6B62] mt-1 text-[10px]">
                  {f.contact && <span>from: {f.contact} · </span>}
                  {f.context && <span>{f.context} · </span>}
                  {fmtDate(f.created_at)}
                </div>
              )}
              {f.status !== "resolved" && (
                <div className="flex gap-2 mt-2">
                  {f.status === "new" && (
                    <button
                      data-testid={`fb-review-${f.id}`}
                      onClick={() => onChangeStatus(f.id, "reviewed")}
                      className="text-[10px] px-2 py-1 rounded-full bg-[#F0EFEA] text-[#5C6B62] hover:bg-[#E5E2DC]"
                    >
                      Mark reviewed
                    </button>
                  )}
                  <button
                    data-testid={`fb-resolve-${f.id}`}
                    onClick={() => onChangeStatus(f.id, "resolved")}
                    className="inline-flex items-center gap-1 text-[10px] px-2 py-1 rounded-full bg-[#2B5339] text-white hover:bg-[#1C2B23]"
                  >
                    <Check size={10} /> Resolve
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
